import approveOfIssuingReportReducer from "./approveOfIssuingReportReducer";

const approveOfIssuingReportReducers = {
    approveOfIssuingReport: approveOfIssuingReportReducer
};

export default approveOfIssuingReportReducers;